import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotPicks from "./components/HotPicks";
import CategoryBrowse from "./components/CategoryBrowse";
import TwistLibrary from "./components/TwistLibrary";
import Ranking from "./components/Ranking";
import Voices from "./components/Voices";
import Faq from "./components/Faq";
import ContactCta from "./components/ContactCta";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const siteSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "吃瓜反差",
      description: "全网吃瓜反差神转折与意外结局的集中盘点网站",
    },
    {
      "@type": "WebSite",
      name: "吃瓜反差",
      inLanguage: "zh-CN",
      description: "吃瓜反差神转折汇总、结局意外盘点、剧情神展开与结尾反转的一次性吃瓜基地",
    },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }} />
      <Navbar />
      <main>
        <Hero />
        <HotPicks />
        <CategoryBrowse />
        <TwistLibrary />
        <Ranking />
        <Voices />
        <Faq />
        <ContactCta />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}